var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmailPrimary(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.1875 3.1875H2.8125C1.26169 3.1875 0 4.44919 0 6V18C0 19.5508 1.26169 20.8125 2.8125 20.8125H21.1875C22.7383 20.8125 24 19.5508 24 18V6C24 4.44919 22.7383 3.1875 21.1875 3.1875ZM22.125 18C22.125 18.5169 21.7044 18.9375 21.1875 18.9375H2.8125C2.29556 18.9375 1.875 18.5169 1.875 18V6C1.875 5.48306 2.29556 5.0625 2.8125 5.0625H21.1875C21.7044 5.0625 22.125 5.48306 22.125 6V18Z",
    fill: "#07689F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9658 4.35645L12 11.7691L2.03418 4.35645L0.915089 5.8609L12 14.1059L23.0849 5.8609L21.9658 4.35645Z",
    fill: "#07689F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailPrimary);
export default __webpack_public_path__ + "static/media/email-primary.89785cd4.svg";
export { ForwardRef as ReactComponent };